import {WlAutoComplete} from "./autocomplete.component";
import { defineWebComponent } from "../webcomponents-utils";

export * from './autocomplete.component';
export * from './autocompleteButton.component';
export * from './autocompleteContent.component';
export * from './autocompleteOption.component';
export default WlAutoComplete;

export const AUTOCOMPLETE_TAG = 'wl-autocomplete';
defineWebComponent(AUTOCOMPLETE_TAG, WlAutoComplete);
